import React, { Fragment } from 'react'
import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text
} from '@chakra-ui/react'
import { useResponsive } from '@common/hooks'
import { replaceAll } from '@lib/util/string'

const ProductTagDetail = ({ text }: { text: string }) => {
  return (
    <Text
      textStyle={'productDetailSmall'}
      dangerouslySetInnerHTML={{
        __html: replaceAll(text ?? '', '<p></p>', '<p>&nbsp;</p>')
      }}
    ></Text>
  )
}

const ProductTagFAQ = ({ text }: { text: string }) => {
  return (
    <Text
      textStyle={'productDetailSmall'}
      dangerouslySetInnerHTML={{
        __html: replaceAll(text ?? '', '<p></p>', '<p>&nbsp;</p>')
      }}
    ></Text>
  )
}

const TabCustom = ({ text, w }: { text: string; w?: string | number }) => {
  return (
    <Tab
      bg={'bgBold'}
      color={'whiteAlpha.900'}
      borderRadius={0}
      h={16}
      w={w || 60}
      _selected={{
        color: 'whiteAlpha.900',
        bg: 'red',
        borderBotom: '0px'
      }}
    >
      <Text fontSize={'lg'} color={'whiteAlpha.900'}>
        {text}
      </Text>
    </Tab>
  )
}

interface PropsType {
  detail: string
  faq: string
}

const ProductTabDetailFAQ = ({ detail, faq }: PropsType) => {
  const { smMax } = useResponsive()

  return (
    <Fragment>
      <Box my={20}>
        <Tabs size="md" variant="enclosed-colored">
          <TabList
            borderBottom={'5px solid'}
            borderBottomColor={'red'}
            display={'flex'}
          >
            {detail !== null && (
              <TabCustom text="Product Detail" w={smMax ? '100%' : 60} />
            )}
            {faq !== null && <TabCustom text="FAQ" w={smMax ? '100%' : 60} />}
          </TabList>
          <TabPanels bg={'bg'} px={5}>
            {detail !== null && (
              <TabPanel>
                <ProductTagDetail text={detail} />
              </TabPanel>
            )}
            {faq !== null && (
              <TabPanel>
                <ProductTagFAQ text={faq} />
              </TabPanel>
            )}
          </TabPanels>
        </Tabs>
      </Box>
    </Fragment>
  )
}

export default ProductTabDetailFAQ
